import { render, staticRenderFns } from "./MemberActivation.vue?vue&type=template&id=0ab5870a&scoped=true&"
import script from "./MemberActivation.vue?vue&type=script&lang=js&"
export * from "./MemberActivation.vue?vue&type=script&lang=js&"
import style0 from "./MemberActivation.vue?vue&type=style&index=0&id=0ab5870a&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ab5870a",
  null
  
)

export default component.exports